import { useParams } from "react-router-dom";
import { t } from "../constants/i18n";
import { useRemoteProducts } from "../hooks/useRemoteData";
import ProjectPage from "./ProjectPage";
import type { Lang } from "../constants/i18n";

interface ProductDetailProps {
  lang: Lang;
}

export default function ProductDetail({ lang }: ProductDetailProps) {
  const { slug } = useParams<{ slug: string }>();
  const { data: PRODUCTS, loading } = useRemoteProducts();
  const entry = PRODUCTS.find((p) => p.slug === slug);

  if (!entry) {
    return (
      <div className="pp">
        <div className="pp-hero">
          <div className="container">
            <p className="pp-not-found">{loading ? "loading..." : "product not found."}</p>
          </div>
        </div>
      </div>
    );
  }

  return <ProjectPage lang={lang} entry={entry} backTo="/products" backLabel={t(lang, "nav_products")} />;
}
